export const softWarning = `This project is now experiencing slower loading times because it contains over 500 campaigns. We recommend creating any new campaigns in a different project. After 1000 campaigns, the ability to create, clone or paste new campaigns will NOT be allowed.
Issue tracking: https://taskei.amazon.dev/tasks/P313439169`;

export const hardError = `This project is now experiencing slower loading times because it contains over 1000 campaigns. For system stability, the ability to create, clone or paste new campaigns will NOT be allowed.
Issue tracking: https://taskei.amazon.dev/tasks/P313439169`;

export const hardErrorCampaignsThreshold = 1000;
